import { cn } from "../../lib/utils";
import type { MaybeStringT } from "../../types/zod/common";

interface Props {
	icon: React.ReactNode;
	words: React.ReactNode | MaybeStringT;
	className?: string;
}

const IconDetail = ({ icon, words, className }: Props) => {
	return (
		<div
			className={cn(
				"flex gap-y-1 gap-x-2 items-center text-sm w-fit text-slate-800 dark:text-slate-200",
				className,
			)}
			style={{ flexWrap: "nowrap" }}
		>
			<span className="flex-shrink-0 [&_svg]:w-5 [&_svg]:h-5">
				{icon}
			</span>
			<span className="flex flex-grow">{words ?? ""}</span>
		</div>
	);
};

export default IconDetail;
